import * as React from 'react'
import * as Redux from 'react-redux'
import { styled } from 'next-yak'

import * as plume from '@ulule/owl-kit-components/next'

import * as env from '@owl-nest/config'
import { t } from '@owl-nest/localize'

import { RootState } from '../../../../reducers'
import * as projectModel from '../../../models/project'

export function Title(): React.ReactElement<unknown> {
  const userConfig = env.useUserEnv()
  const lang = userConfig.lang
  const project = Redux.useSelector<RootState, projectModel.Project>((state) => state.application.project.data)
  const title = project?.coming_soon?.caption?.[lang] ?? t('Be among the first to support this project 👇')

  return (
    <Wrapper>
      <plume.styles.heading.S asDesktop="L">{title}</plume.styles.heading.S>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  text-align: center;

  @media screen and ${plume.BREAKPOINTS.LAPTOP} {
    ${plume.styles.heading.L} {
      display: block;
      margin-bottom: 25px;
    }
  }
`
